/**
 * Copyright (c) 2021 lingdocs.com
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
export var Person;

(function (Person) {
  Person[Person["FirstSingMale"] = 0] = "FirstSingMale";
  Person[Person["FirstSingFemale"] = 1] = "FirstSingFemale";
  Person[Person["SecondSingMale"] = 2] = "SecondSingMale";
  Person[Person["SecondSingFemale"] = 3] = "SecondSingFemale";
  Person[Person["ThirdSingMale"] = 4] = "ThirdSingMale";
  Person[Person["ThirdSingFemale"] = 5] = "ThirdSingFemale";
  Person[Person["FirstPlurMale"] = 6] = "FirstPlurMale";
  Person[Person["FirstPlurFemale"] = 7] = "FirstPlurFemale";
  Person[Person["SecondPlurMale"] = 8] = "SecondPlurMale";
  Person[Person["SecondPlurFemale"] = 9] = "SecondPlurFemale";
  Person[Person["ThirdPlurMale"] = 10] = "ThirdPlurMale";
  Person[Person["ThirdPlurFemale"] = 11] = "ThirdPlurFemale";
})(Person || (Person = {}));